import { render } from "./SliderFive.vue?vue&type=template&id=1770b130"
import script from "./SliderFive.vue?vue&type=script&lang=js"
export * from "./SliderFive.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__